import HttpService from "../util/HttpService";
import ParamEncrypt from "../util/ParamEncrypt";

const CONTEXT_PATH = "/video/api/v2";
class VideoService {
    startRecording = (username: string) => {
        return HttpService.get(CONTEXT_PATH.concat('/video/recording/start/') + ParamEncrypt.encryptData(username));
    }

    stopRecording = (username: string) => {
        return HttpService.get(CONTEXT_PATH.concat('/video/recording/stop/') + ParamEncrypt.encryptData(username));
        // return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat('recording/').concat('stop/').concat(username) );
    }
}

const videoService = new VideoService();
export default videoService;